<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconMove_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="m8.457 3-4.345.036a1.08 1.08 0 0 0-1.076 1.076L3 8.457a1.06 1.06 0 0 0 1.066 1.066 1.08 1.08 0 0 0 1.076-1.076l.017-1.826 4.308 4.308a1.085 1.085 0 0 0 1.535-.007c.426-.426.43-1.113.007-1.535l-4.23-4.23 1.668-.015a1.08 1.08 0 0 0 1.076-1.076A1.06 1.06 0 0 0 8.457 3m0 18-4.345-.036a1.08 1.08 0 0 1-1.076-1.076L3 15.543a1.06 1.06 0 0 1 1.066-1.066 1.08 1.08 0 0 1 1.076 1.076l.017 1.825 4.308-4.308a1.085 1.085 0 0 1 1.535.008c.426.426.43 1.113.007 1.534l-4.23 4.23 1.668.016a1.08 1.08 0 0 1 1.076 1.076A1.06 1.06 0 0 1 8.457 21M19.888 3.036 15.543 3a1.06 1.06 0 0 0-1.066 1.066 1.08 1.08 0 0 0 1.076 1.076l1.668.015-4.23 4.23a1.085 1.085 0 0 0 .007 1.535c.426.426 1.113.43 1.535.007l4.308-4.308.017 1.826a1.08 1.08 0 0 0 1.076 1.076A1.06 1.06 0 0 0 21 8.457l-.036-4.345a1.08 1.08 0 0 0-1.076-1.076M15.543 21l4.345-.036a1.08 1.08 0 0 0 1.076-1.076L21 15.543a1.06 1.06 0 0 0-1.066-1.066 1.08 1.08 0 0 0-1.076 1.076l-.017 1.825-4.308-4.308a1.085 1.085 0 0 0-1.535.008 1.085 1.085 0 0 0-.007 1.534l4.23 4.23-1.668.016a1.08 1.08 0 0 0-1.076 1.076A1.06 1.06 0 0 0 15.543 21"
        clip-rule="evenodd"
    />
</svg>
